import WidgetView from '../widget-view'
import InitiativeTimelineConfig from './initiative-timeline-widget-config'
import InitiativesTimeline from 'scoreboard/initiatives/timeline/initiatives-timeline'
import template from './initiative-timeline-widget-view.hbs'
import _ from 'lodash'
import Dataset from 'scoreboard/datasets/model/dataset'
const { ALL_TIME } = Dataset
import calendars from 'scoreboard/components/calendars'
import globals from 'scoreboard/components/globals'
import moment from 'moment'
import layoutManager from 'scoreboard/components/layout-manager'
import exportState from 'scoreboard/components/export/export-state'
import $ from 'jquery'


const InitiativeTimelineView = WidgetView.extend({

	className: 'widget initiative-timeline-widget initiatives-timeline',

	resizable: true,

	configClass: InitiativeTimelineConfig,

	nonFetchProperties: WidgetView.prototype.nonFetchProperties.concat(
		[
			'showLeftPane', 'showFooter', 'initialExpansion',
			'startDate', 'endDate', 'calendarId', 'startPeriodId', 'endPeriodId',
			'startPeriodDelta', 'endPeriodDelta'
		]),

	initialize: function () {
		WidgetView.prototype.initialize.apply(this, arguments)
		this.listenTo(this.model.wob, 'change:height change:width config:resize', this.resize.bind(this))
	},

	render: function () {
		WidgetView.prototype.render.apply(this, arguments)

		if (this.$('.content').length === 0) {
			this.$el.append(template())
		}

		// #33468 Render title before timeline, in case there aren't any
		// initiatives to render
		this._renderTitle()
		this._renderTimeline()

		this.readyForDisplayAndExport()

		return this
	},

	_renderTimeline: function () {
		// list of initiatives to display in the timeline (including both calculations and tree data)
		let data

		let initiativeId = this.model.properties.get('initiativeId')
		let orgId = this.model.properties.get('organizationId')

		if (initiativeId) {
			// if an initiative ID was specified, that that initiative's subtree
			data = _.cloneDeep(this.model.data.initiativeTrees(initiativeId))
		} else if (orgId) {
			// if an org ID was specified, use all root-level trees for that org
			let trees = this.model.data.initiativeTrees()

			data = _(trees)
				.toPairs()
				.filter(([rootId, initiatives]) => initiatives[0].organizationId == orgId)
				.sortBy(([rootId, initiatives]) => initiatives[0].sortOrder)
				.flatMap(([rootId, initiatives]) => initiatives)
				.cloneDeep()
		}

		if (_.isEmpty(data)) {
			return
		}

		let extent
		if (this.model.initialState && this.model.initialState.extent) {
			// If there is any saved state for the date range, use that instead
			// of the widget settings
			extent = [
				moment(this.model.initialState.extent.startDate),
				moment(this.model.initialState.extent.endDate)
			]
		} else if (this.model.properties.get('calendarId') == ALL_TIME) {
			// If "All Time" is selected, we want to get the earliest start date
			// and latest end date and use that for the range (default scoreboard-gantt
			// behavior uses the range of the selected item)
			let dates = _(data)
				.flatMap(init => [init.aggregatedStartDate, init.aggregatedEndDate])
				.filter(d => !_.isNil(d)).value()

			extent = [ moment(_.min(dates)), moment(_.max(dates)) ]
		} else {
			// if the date range isn't set to "all time", we need to resolve the
			// dates or periods to include (may be relative or absolute)
			let props = this.model.properties.toJSON()

			if (!_.isNil(props.startPeriodId) || !_.isNil(props.startPeriodDelta)) {
				let range = _(props)
					// pick out relevant range properties
					.pick('calendarId', 'startPeriodId', 'endPeriodId', 'startPeriodDelta', 'endPeriodDelta')
					.toPairs()
					// convert them all to integers
					.map(([k, v]) => [k, parseInt(v)])
					.fromPairs()
					.value()
				let periods = calendars.resolveRange(range,
					this.model.options.getPeriodId())
				// use the start date of the first period and the end date of the last period
				extent = [periods[0].start, periods[periods.length - 1].end]
			} else if (!_.isNil(props.startDate) && !_.isNil(props.endDate)) {
				extent = [ moment(props.startDate), moment(props.endDate) ]
			}
		}

		if (extent) {
			// Convert moments to native Dates
			extent = extent.map(d => d.toDate())
		}

		let showFooter = !layoutManager.export && this.model.properties.get('showFooter')
		let initialExpansion = this.model.properties.get('initialExpansion')
		if (layoutManager.export && exportState.shouldApply) {
			// This addresses timeline's without state which includes any dashboard
			// in a briefing that contains a timeline and is not the active slide,
			// in which case `shouldApply` will be false
			initialExpansion = 'collapseAll' // #19062 - don't auto expand timelines
		}
		let showLeftPane = this.model.properties.get('showLeftPane')
		let leftPaneWidth = this.model.constructor.LEFT_PANE_WIDTH // left pane is smaller for widgets, see #18110

		// If the graph has already been rendered, and the data hasn't changed,
		// then the user has only changed layout options
		let onlyLayoutChanged = this.graphView
			&& _.isEqual(data, this.lastRenderedData)

		if (onlyLayoutChanged) {
			this.graphView.layout({ showFooter, showLeftPane, extent, initialExpansion })
		} else {
			this.lastRenderedData = _.cloneDeep(data)
			let org = this.model.data.organizations(data[0].organizationId)

			// If we're creating a new GraphView, we need to make sure there
			// isn't already one there
			this.$('.timeline-container').empty()

			this.graphView = new InitiativesTimeline.GraphView({
				initiativeId: initiativeId || data[0].id,
				data,
				el: this.$('.timeline-container')[0],
				external: true,
				extent: extent,
				showFooter,
				showLeftPane,
				initialExpansion,
				canViewOrg: org.view,
				leftPaneWidth,
				width: this.model.wob.get('width'),
				state: this.model.initialState
			})

			this.graphView.render()
		}
	},

	_renderTitle() {
		var title = this.model.properties.get('label')

		this.$('.title-text')
			.toggleClass('is-not-displayed', !title)
			.find('h3').text(title)

		this.$el.toggleClass('has-title', !!title)
	},

	isDrilldownExcluded: function(el) {
		if ($.contains(this.$('.gantt-header').get(0), el)) {
			return true
		}

		if (this.elIsOrIsDescendantOfSelector(el, '.gantt-mini')) {
			// #45113 the bars in the "minibar" are interactive and should not
			// trigger drilldown
			return true
		}

		if (this.elIsOrIsDescendantOfSelector(el, '.gantt-pane-left')) {
			// #45112 the initiative names in the left pane are interactive and
			// should not trigger drilldown
			return true
		}

		return false
	},

	resize: function () {
		this.graphView && this.graphView.resize({width: this.model.wob.get('width')})
	},

	/**
	 * @override
	 */
	getState: function (opt = {}) {
		return _.invoke(this.graphView, 'getState', opt)
	},

	remove: function () {
		WidgetView.prototype.remove.apply(this, arguments)
		this.graphView && this.graphView.remove()
	}
})

export default InitiativeTimelineView

InitiativeTimelineView.__filename__ = 'dashboards/widgets/initiative-timeline/initiative-timeline-widget-view.js'
